export default function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/datum.js
// module id = 1399
// module chunks = 0